import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { WrapperSiteSidenavActions } from '@next/core-lib/wrapper-site-sidenav';
import { Store } from '@ngrx/store';

export function initializeSidenavState(store: Store): () => void {
  return () => {
    store.dispatch(WrapperSiteSidenavActions.collapseSidenav());
    store.dispatch(WrapperSiteSidenavActions.storeCollapseState());
  };
}

export function provideAppInitializers(): EnvironmentProviders {
  return makeEnvironmentProviders([
    {
      provide: 'APP_INIT',
      useFactory: initializeSidenavState,
      deps: [Store],
      multi: true,
    },
  ]);
}
